import axios from 'axios'
import { ElMessage } from 'element-plus'
import { showLoading, hideLoading } from '@/utils/loading'

const $axios = axios.create({
  // 设置超时时间
  timeout: 30000,
  // 基础url，会在请求url中自动添加前置链接
  // baseURL: 'http://127.0.0.1:7001' // 本地API
  baseURL: 'https://freeapi.darrenliuwei.com' // 线上API
})

// 请求拦截器
$axios.interceptors.request.use(
  config => {
    showLoading('数据加载中...')
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
$axios.interceptors.response.use(
  response => {
    // 响应拦截进来隐藏loading效果，此处采用延时处理是合并loading请求效果，避免多次请求loading关闭又开启
    setTimeout(() => {
      hideLoading()
    }, 200)
    const code = response.status
    if ((code >= 200 && code < 300) || code === 304) {
      return Promise.resolve(response.data)
    } else {
      return Promise.reject(response)
    }
  },
  error => {
    // 响应拦截进来隐藏loading效果，此处采用延时处理是合并loading请求效果，避免多次请求loading关闭又开启
    setTimeout(() => {
      hideLoading()
    }, 200)
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 返回401 清除token信息并跳转到登陆页面
          // store.commit('DEL_TOKEN')
          // router.replace('/login')
          break
        case 404:
          ElMessage.error('网络请求不存在')
          break
        default:
          ElMessage.error(error.response.data.message)
      }
    } else {
      // 请求超时或者网络有问题
      if (error.message.includes('timeout')) {
        ElMessage.error('请求超时！请检查网络是否正常')
      } else {
        ElMessage.error('请求失败，请检查网络是否已连接')
      }
    }
    return Promise.reject(error)
  }
)

export default {
  post(url: string, data: any): any {
    return $axios({
      method: 'post',
      url,
      data
    })
  },
  get(url: string, params: any = null): any {
    return $axios({
      method: 'get',
      url,
      params
    })
  }
}
